   const data = JSON.parse(localStorage.getItem("LoginUser"));
   export const LOCAL_USER = data